import { commonjsGlobal, getDefaultExportFromCjs } from '../../../_virtual/_commonjsHelpers.js';
import { __module as localizedFormat$1 } from '../../../_virtual/localizedFormat.js';

(function (module, exports) {
	!function(e,t){module.exports=t();}(commonjsGlobal,(function(){var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"};return function(t,o,n){var r=o.prototype,i=r.format;n.en.formats=e,r.format=function(t){ void 0===t&&(t="YYYY-MM-DDTHH:mm:ssZ");var o=this.$locale().formats,n=function(t,o){return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var i=r&&r.toUpperCase();return n||o[r]||e[r]||o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,o){return t||o.slice(1)}))}))}(t,void 0===o?{}:o);return i.call(this,n)};}})); 
} (localizedFormat$1));

var localizedFormatExports = localizedFormat$1.exports;
const localizedFormat = /*@__PURE__*/getDefaultExportFromCjs(localizedFormatExports);

export { localizedFormat as default };
//# sourceMappingURL=localizedFormat.js.map
